export const organisationForms = [
  "Partnership or joint venture (ANS, DA, KS or fellesforetak)",
  "Limited liability company (AS, ASA or BA)",
  "Sole proprietorship (Enkeltpersonsforetak)",
  "Norwegian-registered foreign business - NUF foreign entity (Utenlandsk enhet)",
  "Savings bank (Sparebank SPA)",
  "Other business enterprise in accordance with special legislation (SÆR - Annet foretak ifølge særskilt lov)",
  "Corporation",
  "Other (Annet)"
]